// =============================================================================
// dateRange.js — THE timeline vocabulary (Sep 2026)
// =============================================================================
// One formatter for every date-range label in the app (Final Roster's period
// navigator, the Console's timeline, the Solve button, scope-menu sublabels),
// so both tabs speak the same language:
//
//   Same month:   "Mon 1 – Sun 7 Sep"
//   Cross month:  "Mon 29 Sep – Sun 5 Oct"
//   Other year:   "Mon 29 Dec – Sun 4 Jan 2027"   (year only when it isn't
//   Cross year:   "Mon 29 Dec 2025 – Sun 4 Jan 2026"        the current one)
//
// Manual day/month tables instead of toLocaleDateString: locale data varies
// ("Sept" vs "Sep" across ICU versions) and this label must be stable.
// =============================================================================

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function buildRangeLabel(start, end, withWeekday) {
  const currentYear = new Date().getFullYear();
  const sameYear = start.getFullYear() === end.getFullYear();
  const sameMonth = sameYear && start.getMonth() === end.getMonth();
  const endShowsYear = end.getFullYear() !== currentYear || !sameYear;
  const startShowsYear = !sameYear;

  const part = (d, withMonth, withYear) =>
    (withWeekday ? `${WEEKDAYS[d.getDay()]} ` : '') + `${d.getDate()}` +
    (withMonth ? ` ${MONTHS[d.getMonth()]}` : '') +
    (withYear ? ` ${d.getFullYear()}` : '');

  return `${part(start, !sameMonth, startShowsYear)} – ${part(end, true, endShowsYear)}`;
}

/**
 * Format an inclusive date range. Both arguments are Date objects built from
 * LOCAL parts (never `new Date('YYYY-MM-DD')`, which parses as UTC).
 */
export function formatDateRange(start, end) {
  return buildRangeLabel(start, end, true);
}

/**
 * Same range, no weekday — for tight spaces like a button label ("31 Aug –
 * 6 Sep" instead of "Mon 31 Aug – Sun 6 Sep"). The weekday earns its space in
 * a persistent nav control; it's just noise repeated across every Solve/
 * Clear/Publish button in the Management Console toolbar.
 */
export function formatCompactDateRange(start, end) {
  return buildRangeLabel(start, end, false);
}
